/**
 * 提供会话聊天外部调用支撑页面
 */
import { useHistory, useParams } from "react-router-dom";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import ChatMain from "@/components/chat/view/Main";
import ChatRight from "@/components/chat/view/RightSide";
import SidebarSet, { ISetSwitch } from "@/components/chat/SidebarSet";
import CreateSchedule from "@/components/Calendars/Create";
import ChatState, { UserState } from "@/types/chat/State";
import WinToolbar from "@/layout/WinToolbar";
import { connect } from "dva";
import {
  ChatMessage,
  Employee,
  Group,
  GroupRoster,
  Session,
  SessionProps,
  SessionType,
  UID
} from "@/types/chat";
import ImService from "@/server/ImService";
import { parseUidFromString } from "@jd/focus-desktop-comps/lib/es/utils";
import { FocusSDK as focusSDK, isFocusEnv, getParams } from "@/utils";
import "../chat/main.less";
import "./index.less";
import classNames from "classnames";
import Loading from "@/components/Loading";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import {
  getGroupRoster,
  getGroupRosterIdentity,
  getGroupRosterIdentityAndClientType
} from "@/utils/chat/group";
import Context from "@/components/chat/context";
import Bus from "@/utils/bus";
import { isEqualEmployee, uidToEmployee } from "@/utils/chat/message";
import { closeChatWindow } from "@/utils/chat/index";
import { DrawTypeEnum } from "@/components/chat/enum";
import ChatEvent from "@/components/chat/view/ChatEvent";
import config, { ChatConfig, getNetCheckUrl } from "@/config/config";
import CreateTaskDraw from "@/components/Work/CreateTaskDraw";
import GroupSpaceDrawer from "@/components/chat/message/GroupSpaceDrawer";
import JoyspaceFileSelectorModal from "@/components/Modals/JoyspaceFileSelectorModal";
import GroupSlitaire from "@/components/Work/Solitaire";
import SolitaireDetails from "@/components/chat/message/SolitaireCard/SolitaireDetails";
import History from "@/components/chat/message/GroupNotification/components/history";
import UserCardModal from "@/components/Modals/UserCardModal";
import ScheduleDraw from "@/components/Projects/components/CalendarView/ScheduleDraw";
import DeeplinkHandler from "@/components/DeeplinkHandler";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import SuperviseCreate from "@/components/Supervise/components/SuperviseCreate";
import GroupNotificationBox from "@/components/chat/message/GroupNotification";
import NoticeDetailsCard from "@/components/chat/message/GroupNotificationCard/NoticeDetailsCard";
import BaseMeetingCallModal from "@/baseComponents/Meeting/MeetingCallModal";
import TaskDetailDraw from "@/components/Work/TaskDetailDraw";
import TaskDetailEditDraw from "@/components/Work/TaskDetailEditDraw";
import SlitaireHis from "@/components/Work/Solitaire/solitaireHistory";
import NetworkCheck from "@/utils/NetworkCheck";
import { isAIChatSession } from "@/utils/chat/session";
import {
  getCurrentFileControls,
  getCurrentFileSendControls,
  getFileSecurityTagList,
  getDefaultFileTag
} from "@/utils/tools";

interface ChatProps {
  openSetup: boolean;
  selectedSession: Session;
  currentEmployee: Employee;
  userData: any;
  clientConfig: any;
  teamConfig: any;
  administrator: Partial<GroupRoster>[];
  sub_administrator: Partial<GroupRoster>[];
  ordinary: Partial<GroupRoster>[];
  sessionMessageMap: any;
  quickReplys: any[];
  pushChatMessage: Function;
}

interface DvaProps {
  initSelectedSession: Function;
  launchSingleSession: Function;
  launchGroupSession: Function;
  launchNoticeSession: Function;
  launchMeetingSession: Function;
  launchLiveMeetingSession: Function;
  getCurrentEmployee: Function;
  receiveSessionNewMessage: Function;
  receiveSessionBatchMessage: Function;
  updateSessionListState: Function;
  setHistoryMessage: Function;
  setStartMessageId: Function;
  getAllChatSessions: Function;
  getLLMTagsList: Function;
  getLLMAgentList: Function;
  updateLLMInfo: Function;
  updateCurrentAIRobot: Function;
}

type IProps = Readonly<
  ChatProps &
    DvaProps & {
      updateSelectedSession: Function;
      changeGroupAdmin: Function;
    }
>;

const getWebUserInfo = (userData: any) => {
  let userInfo = {} as any;
  const teamUserInfo = userData.teamUserInfo;
  userInfo.userId = userData.userId || "";
  userInfo.teamId = teamUserInfo.teamId || "";
  userInfo.app = teamUserInfo.ddAppId || "";
  return userInfo;
};

const getFocusUserInfo = (userData: any) => {
  let userInfo = {} as any;
  userInfo.userId = userData.userId || "";
  userInfo.teamId = userData.teamUserInfo?.teamId || "";
  userInfo.app = userData.ddAppId || process.env.REACT_APP_DD_APPID || "";
  userInfo.accessToken = userData.accessToken || "";
  userInfo.appId = userData.ddAppId || "";
  userInfo.client = (userData.app?.client || "").toLowerCase();
  userInfo.deviceId = userData.app?.deviceId || "";
  return userInfo;
};

function ChatSupport(props: IProps) {
  const {
    currentEmployee,
    administrator,
    sub_administrator,
    ordinary,
    selectedSession,
    launchSingleSession,
    launchGroupSession,
    launchNoticeSession,
    launchMeetingSession,
    launchLiveMeetingSession,
    getCurrentEmployee,
    receiveSessionNewMessage,
    receiveSessionBatchMessage,
    updateSessionListState,
    userData,
    clientConfig = {},
    updateSelectedSession,
    changeGroupAdmin,
    setHistoryMessage,
    setStartMessageId,
    getAllChatSessions,
    sessionMessageMap,
    getLLMTagsList,
    getLLMAgentList,
    quickReplys,
    teamConfig,
    pushChatMessage,
    updateLLMInfo,
    updateCurrentAIRobot
  } = props;
  // const [imService, setImService] = useState<ImService | null>(null);
  const groupRosters = useMemo(() => {
    if (selectedSession.isSingle) {
      return [];
    }
    if (administrator.length === 0) {
      return [];
    }
    return getGroupRoster(administrator, sub_administrator, ordinary);
  }, [selectedSession, administrator, sub_administrator, ordinary]);

  const isMeetingChat = useMemo(() => {
    return (selectedSession?.sessionId || "").startsWith("mt");
  }, [selectedSession.sessionId]);

  const isLiveMeetingChat = useMemo(() => {
    return (selectedSession?.sessionId || "").startsWith("live");
  }, [selectedSession.sessionId]);

  const { authInfo: userInfo, imService, appRuntimeEnv } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  const [openSetup, setOpenSetup] = React.useState(false);
  const [historySearchOpen, setSearchRecordOpen] = React.useState(false);
  const [shareJoyspaceOpen, setShareJoyspaceOpen] = React.useState(false);
  const [sessionList, setsessionList] = useState<Session>();
  const windowWidthRef = useRef(0);
  const history = useHistory();
  const name = selectedSession?.info?.name;
  if (name) {
    document.title = name;
  }
  console.log("设置document.title", selectedSession, name);
  // 当前组件被渲染后多次，useEffect的document.title = name;被冲掉，故在此处重新设置
  // document.title = name;

  useEffect(() => {
    if (name) {
      document.title = name;
    }
  }, [name]);
  const { im } = appRuntimeEnv;

  useEffect(() => {
    if (!selectedSession || !selectedSession.sessionId) {
      setOpenSetup(false);
      // setSearchRecordOpen(false);
    }
  }, [selectedSession]);

  const type = getParams("type", history);
  const id = getParams("gid", history);
  // const { type, id } = useParams();
  const query = new URLSearchParams(location.search);
  const top = query.get("top") === "true";
  const secret = query.get("secret") || false;
  const [sMid, setSMid] = useState(-1);
  const [sText, setSText] = useState("");
  const user = parseUidFromString(id);
  const [sid, setSid] = useState<null | string>(null);
  // const sid = type === "s" ? imService.generateSingleSessionId(currentEmployee, user) : id;
  useEffect(() => {
    if (!imService) return;
    setSid(type === "s" ? imService.generateSingleSessionId(currentEmployee, user) : id);
  }, [imService]);
  const groupRosterIdentity = useMemo(() => {
    if (selectedSession.isSingle || !currentEmployee) {
      return "";
    }
    if (administrator.length === 0) {
      return "";
    }
    const getIdentity =
      type === "mt"
        ? getGroupRosterIdentityAndClientType(administrator, sub_administrator, currentEmployee)
        : getGroupRosterIdentity(administrator, sub_administrator, currentEmployee);
    return getIdentity;
  }, [selectedSession.isSingle, currentEmployee, administrator, type, sub_administrator]);

  const setParams = useCallback(({ sid = "", sType = "", sMid = "-1", sText = "" }) => {
    setSMid(parseInt(sMid, 10));
    setSText(sText);
  }, []);
  let sessionMessages: any[] = sessionMessageMap[selectedSession.sessionId];
  const lastMessage = useMemo(() => {
    const last = (sessionMessages || []).slice(-1)[0] || {};
    return last;
  }, [sessionMessages]);

  useEffect(() => {
    const sMid = query.get("sMid") || -1;
    const sText = query.get("sText") || "";
    setParams({
      sMid,
      sText
    });
  }, [history, setParams, query]);

  const messageListener = useCallback(
    (message: ChatMessage) => {
      // 接收新开窗口会话新消息 直接发送到dva
      receiveSessionNewMessage({ chatMessage: message });
    },
    [receiveSessionNewMessage]
  );

  const messageBatchListener = useCallback(
    (messages: ChatMessage[]) => {
      receiveSessionBatchMessage(messages);
    },
    [receiveSessionBatchMessage]
  );

  const launchSession = useCallback(async () => {
    if (sMid > -1) {
      setStartMessageId({ sMid, sText });
    }
    if (type === "g" && id) {
      await launchGroupSession({ sid: id, top });
    } else if (type === "s") {
      // TODO: 单聊密聊会话 id是不是有secret
      const type = secret === "true" ? SessionType.SECRET_SINGLE : SessionType.SINGLE;
      if (user?.pin && user?.app && user?.teamId) {
        launchSingleSession({
          top,
          user,
          type
        });
      }
    } else if (type === "n" && id) {
      launchNoticeSession({ sid: id, top });
    } else if (type === "mt" && id) {
      launchMeetingSession({ sid: id, top });
    } else if (type === "live" && id) {
      launchLiveMeetingSession({ sid: id, top });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    id,
    launchGroupSession,
    launchMeetingSession,
    launchLiveMeetingSession,
    launchNoticeSession,
    launchSingleSession,
    sMid,
    sText,
    secret,
    setStartMessageId,
    top,
    type
  ]);
  const imLogin = useCallback(async (authInfo: any) => {
    const imService = ImService.getInstance();
    try {
      await imService.loginIm(
        {
          xToken: authInfo.accessToken,
          xTeamId: authInfo.teamUserInfo?.teamId,
          xClient: (authInfo.app?.client || "").toLowerCase()
        },
        false,
        false
      );
      // if (imService) {
      //   getAllChatSessions();
      // }
      Bus.emit("im:login:success");
    } catch (e) {
      console.log("im--login error--", e);
    }
  }, []);

  const receiveMessage = useCallback(async () => {
    if (!userInfo || !userInfo.userId || !userInfo.teamUserInfo?.teamId) {
      return;
    }
    imLogin(userInfo);
    const imService = ImService.getInstance();

    if (!imService) return;
    // setImService(imService);
    if (ImService.isValid()) {
      await getCurrentEmployee();
      await launchSession();
      imService.removeAllListeners("chat_new_message");
      imService.on("chat_new_message", messageListener);
      imService.removeAllListeners("chat_batch_message");
      imService.on("chat_batch_message", messageBatchListener);
      await updateSessionListState();
    }
  }, [
    getCurrentEmployee,
    imLogin,
    imService,
    launchSession,
    messageBatchListener,
    messageListener,
    updateSessionListState,
    userInfo
  ]);

  const updateGroupRoster = useCallback(async () => {
    if (administrator.length === 0) {
      return;
    }
    const { owner } = selectedSession.info as Group;
    const newAdmin = uidToEmployee(owner) as Employee;
    const oldAdmin = administrator[0].info;
    // 新旧管理员不一样
    if (oldAdmin && newAdmin && !isEqualEmployee(newAdmin, oldAdmin)) {
      // 进行替换管理员操作
      const newAdminRosterIndex = ordinary.findIndex((item: any) =>
        isEqualEmployee(newAdmin, item.info)
      );
      const newAdminRoster = ordinary[newAdminRosterIndex];
      // 替换
      ordinary[newAdminRosterIndex] = {
        ...administrator[0],
        identity: "ordinary"
      };
      administrator[0] = { ...newAdminRoster, identity: "administrator" };
      await changeGroupAdmin({
        ordinary: [...(ordinary || [])],
        administrator: [...(administrator || [])]
      });
    }
  }, [administrator, changeGroupAdmin, ordinary, selectedSession.info]);

  const updateSession = useCallback(
    async (session: SessionProps) => {
      // console.log('sessionUpdateListener 111==>', new Date().toLocaleTimeString());
      if (session.sessionId === selectedSession.sessionId) {
        session.unreadCount = 0;
        if (session.isGroup) {
          const group = session.info as Group;
          if (group.rosterSize > 0) {
            await updateGroupRoster();
          }
        }
        await updateSelectedSession({ selectedSession: session });
      }
    },
    [selectedSession.sessionId, updateGroupRoster, updateSelectedSession]
  );

  // const sessionUpdateListener = lodashThrottle(updateSession, 1000);

  const handleChatManagerUpdate = useCallback((res) => {
    const imService = ImService.getInstance();
    try {
      const d = JSON.parse(res);
      const { name, data } = d;
      switch (name) {
        case "message":
          // chat_new_message
          messageListener(data);
          break;
        case "message-batch":
          imService.emit("chat_batch_message", data);
          break;
        case "documents-select":
          console.log(data, "documents-selects");
          // imService.emit("chat_batch_message", data);
          break;
        case "send-msg":
          if (data?.agentType === "chat") {
            updateCurrentAIRobot({
              type: "chat"
            });
          }
          pushChatMessage({ sessionId: data.sessionId, message: data.data, duplicate: true });
          break;
        case "selectJoyspace":
          updateLLMInfo({
            files: data.list,
            isReady: true
          });
          console.log("ls:>selectJoyspace", data);
          break;
        // 关闭
        case "win-close":
          updateLLMInfo(null);
          break;
        default:
          Bus.emit(`chat:${name}`, data);
          break;
      }
    } catch (e) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEvent = useCallback(
    (data) => {
      launchMeetingSession({
        sid: data?.sessionId
      });
      if (data?.sessionId) {
        ImService.getInstance()
          .loadHistory(data?.sessionId)
          .then((res) => {
            setHistoryMessage({ sessionId: data?.sessionId, historyMessage: res?.messages });
          });
      }
    },
    [setHistoryMessage, launchMeetingSession]
  );

  useEffect(() => {
    focusSDK.on("chatManager:update", handleChatManagerUpdate);
    focusSDK.onIpcMessage("chatManager:winshow", handleEvent);
    return () => {
      focusSDK.off("chatManager:update", handleChatManagerUpdate);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sessionRemoveListener = useCallback(() => {
    closeChatWindow();
  }, []);

  useEffect(() => {
    if (type !== "mt" && sid) {
      Bus.on(`chat:session-remove:${sid}`, sessionRemoveListener);
      return () => {
        Bus.off(`chat:session-remove:${sid}`, sessionRemoveListener);
      };
    }
  }, [type, sid, sessionRemoveListener]);

  useEffect(() => {
    if (userInfo) {
      receiveMessage().then();
    }
    return () => {
      const imService = ImService.getInstance();
      if (ImService.isValid()) {
        imService.removeListener("chat_new_message", messageListener);
        imService.offChatMessage();
      }
    };
  }, [messageListener, receiveMessage, userInfo]);

  function handleResize() {
    windowWidthRef.current = document.body.clientWidth;
  }

  useEffect(() => {
    getLLMAgentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    Bus.emit("chat:state", {
      state: ConnectState.READY
    });
    handleResize();
    window.addEventListener("resize", handleResize);
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl()
    });
    netServer?.off("online", () => {
      launchSession();
    });
    netServer?.on("online", () => {
      launchSession();
    });
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onToggleDraw(type: DrawTypeEnum) {
    switch (type) {
      case DrawTypeEnum.setup:
        setOpenSetup(!openSetup);
        setSearchRecordOpen(false);
        setShareJoyspaceOpen(false);
        break;
      case DrawTypeEnum.search:
        setOpenSetup(false);
        setSearchRecordOpen(!historySearchOpen);
        setShareJoyspaceOpen(false);
        break;
      case DrawTypeEnum.shareJoyspace:
        setOpenSetup(false);
        setSearchRecordOpen(false);
        setShareJoyspaceOpen(!shareJoyspaceOpen);
        break;
    }
  }

  // function handleMainClick() {
  //   if (openSetup && windowWidthRef.current < 1271) {
  //     setOpenSetup(false);
  //     setSearchRecordOpen(false);
  //   }
  // }
  function handleMainClick() {
    if (openSetup) {
      setOpenSetup(false);
      setSearchRecordOpen(false);
      setShareJoyspaceOpen(false);
    }
    setTimeout(() => {
      ChatEvent.closeMention();
    }, 100);
  }

  const containerClassNames = classNames({
    support_chat_container: isFocusEnv(),
    "chat-container": true,
    open: openSetup
  });

  const lastAIMessage = useMemo(() => {
    if (isAIChatSession(selectedSession)) {
      if (!lastMessage) {
        return null;
      }
      if (!(lastMessage as any)?.isMyself) {
        return lastMessage;
      }
    } else {
      return null;
    }
  }, [lastMessage, selectedSession]);

  const quickReply = useMemo(() => {
    return appRuntimeEnv.config.quickReply || {};
  }, [appRuntimeEnv]);

  const userQuickReply = useMemo(() => {
    return clientConfig.quickReply === 0 ? 0 : 1;
  }, [clientConfig.quickReply]);

  const aggregateDuration = useMemo(() => {
    return im.aggregateDuration || 0;
  }, [im]);

  const aiMergeOptions = useMemo(() => {
    const opts = {
      keywords: (teamConfig?.aiMergeKeywords || "").split(","),
      duration: Number(teamConfig?.aiMergeDuration || "3600000"),
      whitelist: (teamConfig?.aiMergeWhiteList || "").split(",")
    };
    return opts;
  }, [teamConfig]);

  // 文件控制
  const fileTagList = useMemo(() => {
    const conf = getFileSecurityTagList(teamConfig);
    return conf || [];
  }, [teamConfig]);

  // 当前文件控制
  const currentFileControl = useMemo(() => {
    const { loginType = "normal" } = userData;
    const conf = getCurrentFileControls(teamConfig, loginType);
    return conf || [];
  }, [teamConfig, userData]);

  // 当前文件发送控制
  const currentFileSendControl = useMemo(() => {
    const conf = getCurrentFileSendControls({
      teamConfig,
      controlList: currentFileControl
    });
    return conf || [];
  }, [teamConfig, currentFileControl]);

  const defaultFileTag = useMemo(() => {
    const id = getDefaultFileTag(fileTagList);
    return id;
  }, [fileTagList]);

  if (!selectedSession.sessionId) {
    return <Loading />;
  }
  // '-webkit-app-region': 'drag',
  return (
    <Context.Provider
      value={{
        lastAIMessage,
        currentEmployee,
        groupRosters,
        groupRosterIdentity,
        userData,
        isMeetingChat,
        isLiveMeetingChat,
        imService,
        lastMessage,
        httpMatchUrls: im.httpMatchList || ["mp.weixin.qq.com", "smart.swj.beijing.gov.cn"],
        blackUrls: im.blackUrlList || [],
        quickReplyConfig: quickReply,
        userQuickReply: userQuickReply,
        aggregateDuration,
        aiMergeOptions,
        fileTagList,
        currentFileControl,
        currentFileSendControl,
        defaultFileTag
      }}
    >
      <div className={containerClassNames}>
        <div
          className="main"
          style={{
            top: selectedSession.sessionId ? "0px" : "60px"
          }}
          onClick={handleMainClick}
        >
          <div className="title">
            {type !== "live" && (
              <div className="draggable">
                <div className="text">{isAIChatSession(selectedSession) ? "" : "聊天"}</div>
                <WinToolbar ishidewin={type === "mt"} isclosewin={type !== "mt"} />
              </div>
            )}
          </div>
          <ChatMain onToggleSetup={onToggleDraw} />
        </div>
        {config[ChatConfig.CHAT_RIGHT_SIDER_ENABLE] && (
          <div className="right">
            <ChatRight
              session={sessionList}
              openSetup={openSetup}
              historySearchOpen={historySearchOpen}
              shareJoyspaceOpen={shareJoyspaceOpen}
              onToggleSetup={onToggleDraw}
              onClickClose={() => {
                onToggleDraw(DrawTypeEnum.search);
              }}
            />
          </div>
        )}
        {type !== "mt" && type !== "live" && (
          <div>
            <GroupSpaceDrawer />
            <JoyspaceFileSelectorModal />
            <CreateSchedule />
            <ScheduleDraw />
            <CreateTaskDraw />
            <GroupSlitaire />
            <SlitaireHis />
            <SolitaireDetails />
            <History />
            <UserCardModal />
            <DeeplinkHandler history={history} />
            <SuperviseCreate />
            <GroupNotificationBox />
            <NoticeDetailsCard />
            <BaseMeetingCallModal />
            <TaskDetailDraw />
            <TaskDetailEditDraw />
          </div>
        )}
        {/* <div className="right">
          <ChatRight
            openSetup={openSetup}
            historySearchOpen={historySearchOpen}
            onToggleSetup={() => {
              setOpenSetup(!openSetup);
              setSearchRecordOpen(false);
            }}
          />
          {selectedSession.sessionId && (
            <SidebarSet
              openSetup={openSetup}
              historySearchOpen={historySearchOpen}
              setCallBack={(props: ISetSwitch) => {
                if (typeof props.openSetup !== "undefined") {
                  setOpenSetup(props.openSetup);
                }
                if (typeof props.historySearchOpen !== "undefined") {
                  setSearchRecordOpen(props.historySearchOpen);
                }
              }}
            />
          )}
          {selectedSession.sessionId && <SupportUserCard />}
        </div> */}
      </div>
    </Context.Provider>
  );
}
function mapStateToProps({ chat, user }: any) {
  const { userData, clientConfig, teamConfig } = user;
  const {
    selectedSession,
    administrator,
    sub_administrator,
    ordinary,
    currentEmployee,
    sessionMessageMap,
    quickReplys
  } = chat as ChatState;
  return {
    clientConfig,
    teamConfig,
    userData: userData.user || {},
    selectedSession,
    administrator,
    sub_administrator,
    ordinary,
    currentEmployee,
    sessionMessageMap,
    quickReplys
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    receiveSessionNewMessage(data: { chatMessage: ChatMessage }) {
      return dispatch({ type: "chat/receiveSessionNewMessage", payload: data });
    },
    receiveSessionBatchMessage: (messages: any) => {
      dispatch({
        type: "chat/receiveSessionBatchMessage",
        payload: { chatMessages: messages }
      });
    },
    async updateSelectedSession(data: { selectedSession: SessionProps }) {
      await dispatch({ type: "chat/updateSelectedSession", payload: data });
    },
    async changeGroupAdmin(data: {
      ordinary: Partial<GroupRoster>[];
      administrator: Partial<GroupRoster>[];
    }) {
      await dispatch({ type: "chat/changeGroupAdmin", payload: data });
    },
    getCurrentEmployee() {
      return dispatch({ type: "chat/getCurrentEmployee", payload: {} });
    },
    launchSingleSession(data: { user: UID; top?: boolean }) {
      return dispatch({ type: "chat/launchSingleSession", payload: data });
    },
    launchGroupSession(data: { sid: string; top?: boolean }) {
      return dispatch({ type: "chat/launchGroupSession", payload: data });
    },
    launchMeetingSession(data: { sid: string; top?: boolean }) {
      return dispatch({ type: "chat/launchMeetingSession", payload: data });
    },
    launchLiveMeetingSession(data: { sid: string; top?: boolean }) {
      return dispatch({ type: "chat/launchLiveMeetingSession", payload: data });
    },
    launchNoticeSession(data: { sid: string; top?: boolean }) {
      return dispatch({ type: "chat/launchNoticeSession", payload: data });
    },
    updateSessionListState(data: {}) {
      return dispatch({ type: "chat/updateSessionListState", payload: data });
    },
    setHistoryMessage(data: { sessionId: string; historyMessage: ChatMessage }) {
      return dispatch({ type: "chat/setHistoryMessage", payload: data });
    },
    setStartMessageId(data: { sMid: number; sText: string }) {
      dispatch({ type: "chat/setStartMessageId", payload: data });
    },
    getAllChatSessions: () => {
      dispatch({ type: "chat/getAllChatSessions", payload: {} });
    },
    getLLMTagsList() {
      dispatch({ type: "chat/getLLMTagsList", payload: {} });
    },
    getLLMAgentList() {
      dispatch({ type: "chat/getLLMAgentList", payload: {} });
    },
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    },
    updateLLMInfo(data: any) {
      dispatch({ type: "chat/updateLLMInfo", payload: data });
    },
    updateCurrentAIRobot(payload: any) {
      dispatch({ type: "chat/updateCurrentAIRobot", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatSupport);
